import { Pipe, PipeTransform } from '@angular/core';
import { BOOLEAN_LABEL_KEYS } from 'src/app/core/helpers/ui/ui.constant';

@Pipe({
  name: 'booleanToYesNo',
})
export class BooleanToYesNoPipe implements PipeTransform {
  transform(value: boolean): string {
    return value ? BOOLEAN_LABEL_KEYS.TRUE : BOOLEAN_LABEL_KEYS.FALSE;
  }
}
